import React from "react";
import { Image as ImageIcon } from "lucide-react";
import { mediaUrl } from "@/lib/api";

const GOLD = "#B08A3C";
const STEEL = "#3F5968";
const IVORY = "#F6F1E8";

// 2x2 image quad. Overall box keeps the original portrait ratio (515:646);
// every panel is equal size with consistent narrow gutters (the gold tint between cells).
export function ImageQuad({ panels = [] }) {
  const cells = [0, 1, 2, 3].map((i) => panels[i] || { image: "", alt: "" });
  return (
    <div className="w-full max-w-[515px]">
      <div
        className="grid aspect-[515/646] grid-cols-2 grid-rows-2 gap-2 p-2"
        style={{ border: `1px solid ${GOLD}66`, backgroundColor: `${GOLD}26` }}
        data-testid="image-quad"
      >
        {cells.map((c, i) => (
          <div key={i} className="relative overflow-hidden" style={{ backgroundColor: IVORY }} data-testid={`quad-panel-${i}`}>
            {c.image ? (
              <img src={mediaUrl(c.image)} alt={c.alt || ""} loading="lazy" className="h-full w-full object-cover object-center" />
            ) : (
              <div className="flex h-full w-full flex-col items-center justify-center gap-2" style={{ color: `${STEEL}80` }} aria-hidden="true">
                <ImageIcon className="h-6 w-6" strokeWidth={1.25} />
                <span className="font-sans text-[11px] uppercase tracking-[0.14em]">Image {i + 1}</span>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
